import { Organization } from "@/hooks/types";
import { createContext } from "react";

export const OrganizationContext = createContext<Organization | null>(null);
